import Template from '@/api/template.api.js'

/*eslint-disable */
export const getTemplates = ({ commit }, data) => {
  return Template.getTemplates(data)
  .then(response => {
      let data = [];
      if (response) {
        data = response.data;
        commit("SET_TEMPLATES", response.data.results)
      }
      return data;
    })
}

export const createTemplate = ({ commit }, data) => {
  return Template.createTemplate(data)
    .then(response => {
      return response;
    })
}

export const deleteTemplate = ({ commit }, id) => {
  return Template.deleteTemplate(id)
    .then(response => {
      return response.data;
    })
}

export const deleteBatch = ({ commit }, data) => {
  return Template.deleteBatch(data)
    .then(response => {
      return response.data;
    })
}

export const deleteCollection = ({ commit }, id) => {
  return Template.deleteCollection(id)
    .then(response => {
      return response.data;
    })
}

export const reRunTemplateBatch = ({ commit }, data) => {
  return Template.reRunTemplateBatch(data)
    .then(response => {
      return response.data;
    })
}

export const getExportXlsx = ({ commit }, data) => {
  return Template.getExportXlsx(data)
    .then(response => {
      return response.data;
    })
}

export const addTemplateBatch = ({ commit }, data) => {
  return Template.addTemplateBatch(data)
    .then(response => {
      return response;
    })
}

export const deleteTemplateBatch = ({ commit }, data) => {
  return Template.deleteTemplateBatch(data)
    .then(response => {
      return response;
    })
}
export const addNoteTemplateBatch = ({ commit }, data) => {
  return Template.addNoteTemplateBatch(data)
    .then(response => {
      return response;
    })
}

export const getTemplate = ({ commit }, data) => {
  return Template.getTemplate(data)
    .then(response => {
    if (response.success) {
        commit("SET_TEMPLATE", response.data)
    }
      return response.data;
    })
}
export const getResult = ({ commit }, data) => {
  return Template.getTemplate(data)
    .then(response => {
    if (response.success) {
        commit("SET_RESULT", response.data);
        commit("SET_TEMPLATE", response.data);
    }
      return response.data;
    })
}

export const storeTemplateBox = ({ commit }, data) => {
  return Template.storeTemplateBox(data)
    .then(response => {
      if (response.success && response.data && response.data.id) {
        commit("SET_TEMPLATE", response.data)
      }
      return response.data;
    })
}

export const getTemplateResult = ({ commit }, data) => {
  return Template.getTemplateResult(data)
    .then(response => {
      return response.data;
    })
}

export const getBatchResultCsv = ({ commit }, data) => {
  return Template.getBatchResultCsv(data)
    .then(response => {
      return response.data;
    })
}

export const confirmResult = ({ commit }, data) => {
  return Template.confirmResult(data)
    .then(response => {
      return response.data;
    })
}

export const getBatchList = ({ commit }, data) => {
  return Template.getBatchList(data)
    .then(response => {
      let data = [];
      if (response) {
        data = response.data;
        commit("SET_BATCHES", response.data.results)
      }
      return data;
    })
}

export const getBatch = ({ commit }, data) => {
  commit("SET_BATCH", data)
}

export const saveTemplateAssignment = ({ commit }, data) => {
  return Template.saveTemplateAssignment(data)
    .then(response => {
      return response.data;
    })
}
export const saveTemplateName = ({ commit }, data) => {
  return Template.saveTemplateName(data)
    .then(response => {
      return response.data;
    })
}

export const saveBatchName = ({ commit }, data) => {
  return Template.saveBatchName(data)
    .then(response => {
      return response.data;
    })
}

export const searchTemplateName = ({ commit }, data) => {
  return Template.searchTemplateName(data)
    .then(response => {
      commit("SET_TEMPLATES", response.data.results)
      return response.data;
    })
}

export const searchBatchName = ({ commit }, data) => {
  return Template.searchBatchName(data)
    .then(response => {
      return response.data;
    })
}

export const exportXlsx = ({ commit }, data) => {
  return Template.exportXlsx(data)
    .then(response => {
      return response.data;
    })
}

export const exportXlsxCompress = ({ commit }, data) => {
    return Template.exportXlsxCompress(data)
        .then(response => {
            return response.data;
        })
}


export const getUser = ({ commit }, data) => {
  return Template.getUser(data)
    .then(response => {
      return response.data;
    })
}

export const updateSettingUser = ({ commit }, data) => {
  return Template.updateSettingUser(data)
    .then(response => {
      return response.data;
    })
}
/*eslint-enable */
export const logoutTemplate = ({commit}) => {
    commit('LOGOUT_TEMPLATE');
}
